/**
 * Menu panel memory — v6.1
 * Anchor = history entry (seq), URL nahi.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'menu:panel-path:v6';
  var SEQ_KEY     = 'menu:nav-seq:v6';
  var MAX_AGE     = 30 * 60 * 1000;
  var MAX_DEPTH   = 5;
  var DRAWER      = 'navigation-drawer';
  var ROOT        = '.panel-list__wrapper';
  var CLOSE       = 'is-close-button, [is="close-button"]';
  var FORWARD     = /^(\d+)-(\d+)$/;

  var record    = null;
  var livePath  = [];
  var settled   = false;
  var replaying = false;
  var leaving   = false;
  var mySeq     = 0;

  function here() { return location.pathname + location.search; }

  function navType() {
    try {
      var e = performance.getEntriesByType('navigation')[0];
      if (e && e.type) return e.type;
    } catch (err) {}
    var t = performance.navigation && performance.navigation.type;
    return t === 2 ? 'back_forward' : t === 1 ? 'reload' : 'navigate';
  }

  /* ---------- history entry stamp ---------- */

  function stampSeq() {
    var state = history.state;
    if (state && typeof state.__menuSeq === 'number') return state.__menuSeq;

    var next = 1;
    try {
      next = (parseInt(sessionStorage.getItem(SEQ_KEY), 10) || 0) + 1;
      sessionStorage.setItem(SEQ_KEY, String(next));
    } catch (e) {}

    try {
      var merged = {};
      if (state && typeof state === 'object') {
        for (var k in state) if (Object.prototype.hasOwnProperty.call(state, k)) merged[k] = state[k];
      }
      merged.__menuSeq = next;
      history.replaceState(merged, '');
    } catch (e) {}

    return next;
  }

  /* ---------- storage ---------- */

  function persist() {
    try {
      if (!livePath.length) return forget();
      record = record || {};
      record.path = livePath;
      record.seq  = mySeq;
      record.url  = here();
      record.at   = Date.now();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {}
  }

  function forget() {
    record = null;
    livePath = [];
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function sanitize(raw) {
    var out = [];
    if (!Array.isArray(raw)) return out;
    for (var i = 0; i < raw.length && i < MAX_DEPTH; i++) {
      var entry = raw[i];
      if (!entry || typeof entry.p !== 'string') break;
      var match = FORWARD.exec(entry.p);
      if (!match || parseInt(match[1], 10) !== i + 1) break;
      out.push({ p: entry.p, t: typeof entry.t === 'string' ? entry.t : '' });
    }
    return out;
  }

  function recall() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.seq !== 'number') { forget(); return null; }
      if (Date.now() - data.at > MAX_AGE) { forget(); return null; }
      var path = sanitize(data.path);
      if (!path.length) { forget(); return null; }
      return {
        path: path,
        seq:  data.seq,
        url:  typeof data.url === 'string' ? data.url : '',
        at:   data.at
      };
    } catch (e) { return null; }
  }

  function label(el) {
    var text = el.querySelector('.text, p, span');
    return ((text || el).textContent || '').trim().slice(0, 40);
  }

  function drawerEl() { return document.querySelector(DRAWER); }
  function rootEl()   { var d = drawerEl(); return d ? d.querySelector(ROOT) : document.querySelector(ROOT); }
  function isOpen()   { var d = drawerEl(); return !!(d && d.hasAttribute('open')); }
  function findTrigger(v) { var r = rootEl(); return r ? r.querySelector('[data-panel="' + v + '"]') : null; }

  /* ---------- track ---------- */

  document.addEventListener('click', function (event) {
    if (!event.isTrusted || replaying) return;

    var target = event.target;
    if (!target || !target.closest || !target.closest(ROOT)) return;

    if (target.closest(CLOSE)) { if (livePath.length) forget(); return; }

    var trigger = target.closest('[data-panel]');
    if (trigger) {
      var value = trigger.getAttribute('data-panel');
      var match = FORWARD.exec(value);

      if (match) {
        var level = parseInt(match[1], 10);
        if (level < 1 || level > MAX_DEPTH) return;
        livePath.length = level - 1;
        livePath.push({ p: value, t: label(trigger) });
      } else {
        var back = parseInt(value, 10);
        livePath.length = isNaN(back) ? 0 : Math.max(0, Math.min(back, livePath.length));
      }

      persist();
      return;
    }

    var link = target.closest('a[href]');
    if (!link || !livePath.length) return;
    if (link.target && link.target !== '_self') return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;

    var url;
    try { url = new URL(link.href, location.href); } catch (e) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname + url.search === here()) return;

    leaving = true;
    persist();
  }, true);

  function watchClose() {
    var d = drawerEl();
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (replaying || leaving) return;
      if (!d.hasAttribute('open') && livePath.length) forget();
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  window.addEventListener('pagehide', function () { leaving = true; });

  /* ---------- restore ---------- */

  function activate(el) {
    var r = el.getBoundingClientRect();
    var init = {
      bubbles: true, cancelable: true, composed: true,
      view: window, detail: 1, button: 0,
      clientX: r.left + r.width / 2,
      clientY: r.top + r.height / 2
    };
    var pointer = { pointerId: 1, isPrimary: true, pointerType: 'mouse' };
    try {
      el.dispatchEvent(new PointerEvent('pointerdown', Object.assign({}, init, pointer, { buttons: 1 })));
      el.dispatchEvent(new MouseEvent('mousedown', Object.assign({}, init, { buttons: 1 })));
      el.dispatchEvent(new PointerEvent('pointerup', Object.assign({}, init, pointer)));
      el.dispatchEvent(new MouseEvent('mouseup', init));
    } catch (e) {}
    el.dispatchEvent(new MouseEvent('click', init));
  }

  function isMega(d) {
    return d.hasAttribute('mega-menu') &&
           window.matchMedia('(min-width:1150px)').matches;
  }

  // theme.js module hai — upgrade hone tak show()/switchToPanel() exist nahi karte
  function drawerReady() {
    var d = drawerEl();
    if (!d) return Promise.resolve(null);
    if (typeof d.switchToPanel === 'function') return Promise.resolve(d);
    if (!window.customElements) return Promise.resolve(d);
    return customElements.whenDefined(d.localName).then(function () {
      try { customElements.upgrade(d); } catch (e) {}
      return drawerEl();
    });
  }

  function openDrawer(d) {
    if (!d) return;
    if (d.hasAttribute('open')) return;
    if (typeof d.show === 'function') { d.show(); return; }
    var toggle = d.id && document.querySelector('[aria-controls="' + d.id + '"]');
    if (toggle) activate(toggle);
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.hasAttribute('open')) return;
    if (typeof d.hide === 'function') d.hide(); else d.removeAttribute('open');
  }

  function waitOpen(d, tries, cb) {
    if (d.hasAttribute('open')) return cb(true);
    if (tries <= 0) return cb(false);
    setTimeout(function () { waitOpen(d, tries - 1, cb); }, 50);
  }

  function applyPath(d, path) {
    var mega = isMega(d);

    for (var i = 0; i < path.length; i++) {
      var match   = FORWARD.exec(path[i].p);
      var trigger = findTrigger(path[i].p);

      if (!match || !trigger) return false;
      if (path[i].t && label(trigger) !== path[i].t) return false;

      var a = parseInt(match[1], 10), b = parseInt(match[2], 10);
      try {
        if (mega && typeof d.showPanel === 'function') {
          if (typeof d.setExpanded === 'function') d.setExpanded(trigger);
          d.showPanel(a, b);
        } else if (typeof d.switchToPanel === 'function') {
          d.switchToPanel(a, b);
        } else {
          activate(trigger);
        }
      } catch (e) { return false; }
    }
    return true;
  }

  function restore(path) {
    if (settled) return;
    settled   = true;
    replaying = true;

    drawerReady().then(function (d) {
      if (!d) { replaying = false; forget(); return; }
      openDrawer(d);

      waitOpen(d, 12, function (opened) {
        if (!opened) { closeDrawer(); forget(); replaying = false; return; }

        requestAnimationFrame(function () {
          if (!applyPath(d, path)) { closeDrawer(); forget(); }
          var active = document.activeElement;
          if (active && active.closest && active.closest(ROOT)) active.blur();
          setTimeout(function () { replaying = false; }, 100);
        });
      });
    });
  }

  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ---------- boot ---------- */

  function decide(kind) {
    var rec = recall();
    if (!rec) { settled = true; return; }

    if (rec.seq === mySeq) {
      record   = { seq: rec.seq, url: rec.url, at: rec.at };
      livePath = rec.path.slice();

      if (kind === 'back_forward' || kind === 'reload') {
        persist();
        whenReady(function () { restore(rec.path); });
      } else {
        settled = true;
      }
      return;
    }

    if (mySeq === rec.seq + 1) {
      record   = null;
      livePath = [];
      settled  = true;
      return;
    }

    forget();
    settled = true;
  }

  function boot(kind) {
    mySeq = stampSeq();
    watchClose();
    decide(kind);
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    leaving   = false;
    settled   = false;
    replaying = false;
    mySeq     = stampSeq();
    if (isOpen()) { settled = true; return; }
    decide('back_forward');
  });

  window.addEventListener('popstate', function () {
    leaving   = false;
    settled   = false;
    replaying = false;
    mySeq     = stampSeq();
    if (isOpen()) { settled = true; return; }
    decide('back_forward');
  });

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', function () { boot(navType()); }, { once: true });
  } else {
    boot(navType());
  }
})();